import { HisRule, SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { new_ErrorAlert } from "./ExportManager";
import { HisBasic } from "./HisBasic";
import { HisRow, SpwkHisStep } from "./HisRow";
import { ToDistinctArray } from "./HisRowParser_既往病史_自覺症狀";
import { SpwkMetaData } from "./SpwkMetaData";
import { SpwkMetaTable } from "./SpwkMetaTable";

export class HisRowParser_生活習慣 {

  static ConvertToHisRow(step: SpwkHisStep, his_basic: HisBasic, meta_table: SpwkMetaTable): HisRow[] {

    if (step.Chapter !== SpwkUtilV3.CHAPTER_生活習慣) {
      throw new Error("必須是 生活習慣 !!!");
    }

    const re: HisRow[] = [];

    let questions = meta_table.FilterQuestions_ByChapter(step.Chapter);
    let count = 0

    for (const q_meta of questions) {// 對所有此Chaoter 的 Question，嚴格依照 Q_CODE 來解碼
      count++;
      if (q_meta.q_his_rule === HisRule.CH5) {
        if (q_meta.kind === SpwkUtilV3.Q_KIND_單選) {
          let data_row: HisRow = HisRowParser_生活習慣.Parse基礎生活習慣_單選(q_meta, step, his_basic, meta_table);
          re.push(data_row);

        } else if (q_meta.kind === SpwkUtilV3.Q_KIND_多選) {
          if (q_meta.func_code === 'B19') {
            let data_row: HisRow = HisRowParser_生活習慣.Parse基礎生活習慣_多選(q_meta, step, his_basic, meta_table);
            data_row.項目 = (count).toString()//陣列執行第幾次
            data_row.結果 = data_row.結果 == '' ? '0' : data_row.結果
            re.push(data_row);
          } else {
            let data_row: HisRow = HisRowParser_生活習慣.Parse基礎生活習慣_多選(q_meta, step, his_basic, meta_table);
            re.push(data_row);
          }
        } else {
          throw new_ErrorAlert("468461 生活習慣 只能是 單選 或 多選 !!!");
        }

      } else if (q_meta.q_his_rule === HisRule.PASS) {
        // pass;
      } else {
        throw new_ErrorAlert("6434874 未知的生活習慣!!!q_guid:" + q_meta.data_guid);
      }
    }


    return re;
  }


  static Parse基礎生活習慣_單選(q_meta: SpwkMetaData, step: SpwkHisStep, his_basic: HisBasic, meta_table: SpwkMetaTable): HisRow {
    const data_row: HisRow = new HisRow(his_basic, step.HIS類別代碼);// 5.1=3、5.2=1、5.3=4...

    data_row.項目 = q_meta.his_code;

    let find = meta_table.GetRadioOption_HisCodeBundle(q_meta);// 取得單選選項對應的 his_code

    data_row.結果 = find.his_code;

    if (find.opt_meta != null) {
      let input_code_prefix = step.HIS類別代碼 + "_" + data_row.項目 + "_" + data_row.結果;// 範例

      let inputs = meta_table.FilterInputs_ByOptionGuid(find.opt_meta.data_guid);

      if (inputs.length !== 0) {
        data_row.備註 = HisRowParser_生活習慣.取得備註文字(inputs, input_code_prefix);
      }

      // let inputs = meta_table.meta_rows.filter(x =>
      //   x.data_type === SpwkMetaData_DataType.Input
      //   && x.question_guid === q_meta.question_guid
      //   && x.his_code.startsWith(input_code_prefix)
      // );
      // 找出 input.his_code="5_1_3[1]" 這樣格式的
      // index 從1開始
    }

    return data_row;
  }

  static Parse基礎生活習慣_多選(q_meta: SpwkMetaData, step: SpwkHisStep, his_basic: HisBasic, meta_table: SpwkMetaTable): HisRow {
    const data_row: HisRow = new HisRow(his_basic, step.HIS類別代碼);// 5.1=3、5.2=1、5.3=4...

    data_row.項目 = q_meta.his_code;

    let rslt = meta_table.GetCheckOption_HisCodeAndMetaList_Bundle(q_meta);

    const 結果 = ToDistinctArray(rslt.his_code_list).join(',');
    data_row.結果 = 結果;

    return data_row;
  }




  private static 取得備註文字(inputs: SpwkMetaData[], input_code_prefix: string) {
    //#region 確保 input 事由 1~N 排列
    let ptr_idx = 1; // 從1開始，驗證 his_code 必須是 5_1_3[1]、5_1_3[2]...5_1_3[n]
    for (const inp of inputs) {
      if (inp.his_code !== input_code_prefix + "[" + ptr_idx + "]") {
        throw new_ErrorAlert("98491 input 必須為 5_1_3[1]、5_1_3[2]...5_1_3[n] 順序排列 !!!\n" +
          "請確認規則是否改變 或 設定錯誤!!!\n" +
          "input_guid:" + inp.data_guid);
      }
      ptr_idx++;
    }
    //#endregion

    let str_ary = [];
    for (const input of inputs) {
      str_ary.push("" + (input.rhf_value ?? ""));
    }

    let 備註 = input_code_prefix + "#" + str_ary.join("@");
    return 備註;
  }
}


